export enum FilterEnum {
  TITLE = 'TITLE',
  AUTHOR = 'AUTHOR',
  DELIVERY_DATE = 'DELIVERY_DATE',
  PUBLICATION_DATE = 'PUBLICATION_DATE',
  GRADE = 'GRADE',
  STATUS = 'STATUS',
}
